import {
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { DEMO_API_CONFIG } from './demo-api.tokens';
import { DemoApiConfig } from './demo-api.types';

export function provideDemoApi(
  config: DemoApiConfig,
): EnvironmentProviders {
  if (config.enabled && !config.baseUrl.trim()) {
    throw new Error(
      'La URL de demo-api es obligatoria cuando la integración está habilitada.',
    );
  }

  return makeEnvironmentProviders([
    {
      provide: DEMO_API_CONFIG,
      useValue: {
        ...config,
        baseUrl: config.baseUrl.replace(/\/+$/, ''),
      } satisfies DemoApiConfig,
    },
  ]);
}
